var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-block flex align-center justify-center",style:({ height: _vm.height })},[_c(_vm.getTypeComponent,{tag:"component",attrs:{"title":_vm.title,"description":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }